<ng-container *ngIf="lineItems$ | async as lineItems; else emptyBlock">
  <div class="product-rows-block">
    <ish-basket-error-message *ngIf="basketError$ | async as basketError" [error]="basketError" cssClass="text-danger">
    </ish-basket-error-message>
    <ish-basket-validation-results></ish-basket-validation-results>
    <div *ngFor="let lineItem of lineItems | slice : 0 : maxItemNumber" class="product-row">
      <ng-container ishProductContext [sku]="lineItem.productSKU">
        <div class="mini-product-img">
          <ish-product-image imageType="S" [link]="true"></ish-product-image>
        </div>
        <div class="mini-product-info">
          <ish-product-name></ish-product-name>
          <div class="position-absolute mini-cart-icons">
            <a class="mini-cart-cog">
              <custom-edit-line-item [pli]="lineItem" [icon]="['fas', 'cog']"></custom-edit-line-item>
            </a>
            <custom-mini-cart-remove-item-confirmation-modal
              *ngIf="!lineItem.isFreeGift"
              (confirm)="onDeleteItem(lineItem.id)"
              [options]="options"
            >
              <p>{{ 'mini_cart.remove_item.confirmation.modal.content' | translate }}</p>
            </custom-mini-cart-remove-item-confirmation-modal>
          </div>
          <div class="cart-pli-data">
            <span>{{ 'shopping_cart.pli.qty.label' | translate }}</span> {{ lineItem.quantity.value }}
          </div>
          <div class="product-price">{{ lineItem.price | ishPrice }}</div>
        </div>
      </ng-container>
    </div>
    <div
      *ngIf="maxItemNumber && lineItems.length >= maxItemNumber + 1"
      class="alert alert-info mb-0"
      data-testing-id="show-all-cart-items-hint"
    >
      {{ 'shopping_cart.ministatus.show_all_items.text' | translate }}
    </div>
  </div>

  <div class="mini-cart-bottom-section">
    <div class="mini-cart-subtotal">
      <label>Cart Subtotal:</label>

      <ng-container *ngIf="itemTotal$ | async as itemTotal">
        <span class="mini-cart-price">{{ itemTotal | ishPrice }}</span>
      </ng-container>
    </div>

    <a class="view-cart btn btn-primary btn-lg btn-block" routerLink="/basket">
      {{ 'shopping_cart.ministatus.view_cart.link' | translate }}
    </a>

    <button
      *ishHasNotRole="['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER']"
      type="submit"
      class="btn btn-lg btn-block btn-primary"
      (click)="minicheckout()"
    >
      {{ 'shopping_cart.proceed_to_checkout.button.label' | translate }}
    </button>
  </div>
</ng-container>

<ng-template #emptyBlock>
  <ish-basket-error-message *ngIf="basketError$ | async as basketError" [error]="basketError" cssClass="text-danger">
  </ish-basket-error-message>
  {{ 'shopping_cart.ministatus.empty_cart.text' | translate }}
</ng-template>
